import React from 'react';
import { useQuery } from '@apollo/client';
import FetchUserMealsQuery from './FetchUserMealsQuery';

type result = {
  loading: boolean;
  userMeals?: any;
};

interface IFetchUserMealsConnectorApolloProps {
  children: (result: result) => React.ReactElement;
}

export const FetchUserMealsConnectorApollo: React.FC<IFetchUserMealsConnectorApolloProps> = ({
  children,
}) => {
  const { loading, data, error } = useQuery(FetchUserMealsQuery);

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.userMeals = data.dailyTracker.userMeals.edges.map((edge: any) => edge.node);
  }

  return children(result);
};

export default FetchUserMealsConnectorApollo;
